<template>
  <b-row>
    <b-col lg="8" sm="12">
      <b-card>
        <b-col>
          <Calendar
            :idUserData="idUserData"
          ></Calendar>
        </b-col>
      </b-card>
      <DispatcherTasks v-if="ableToAssignTask && !isServiceman" :displayAssignedTasks="true" :displayNotAssignedTasks="true"></DispatcherTasks>
    </b-col>
    <b-col lg="4" sm="12">
      <b-card v-if="canViewRelations" >
        <b-col class="mt-2">
          <upcoming-relations
            :idUserData="idUserData"
            @setContactType="contactType = $event"
          ></upcoming-relations>
        </b-col>
      </b-card>
      <b-card v-if="canViewRelations" >
        <b-col class="mt-2">
          <upcoming-relations
            :idUserData="idUserData"
            :contact-type="2"
            @setContactType="contactType = $event"
          ></upcoming-relations>
        </b-col>
      </b-card>
      <b-card v-if="canViewNotes">
        <b-col class="mt-2">
        <timetable-notes
        ></timetable-notes>
        </b-col>
      </b-card>
      <PhoneCreateModal></PhoneCreateModal>
      <MeetingCreateModal></MeetingCreateModal>
      <dispatch-task-modal></dispatch-task-modal>
    </b-col>
    <b-col cols="12" v-if="ableToViewCases">
      <b-card v-if="true">
        <b-tabs v-model="tabIndex">
          <!--          moje zadania -->
          <b-tab>
            <template v-slot:title>
              <h6>{{ $t('views.timetable.dashboard.myCasesHeader') }}</h6>
            </template>
            <div class="float-right btn-group mt-2 mb-2">
              <input type="search" class="mr-2 form-control"
                     :placeholder="$t('buttons.quickSearch')" @input="fetchTotalPoolCases()"
                     v-model.lazy="myCasesSearchParams.caseQuickSearch" v-debounce="delay">
            </div>
            <Table @reload="fetchTotalPoolCases()" v-if="tabIndex === 0" class="pt-2" :search-params="myCasesSearchParams"></Table>
            <UpdateTaskParamsModal v-if="tabIndex === 0" @reload="fetchTotalPoolCases()"></UpdateTaskParamsModal>
          </b-tab>
<!--          <b-tab>-->
<!--            <template v-slot:title>-->
<!--              <h6>{{ $t('views.timetable.dashboard.poolCases') }} - ({{ totalPoolCases }})</h6>-->
<!--            </template>-->
<!--            <Table @reload="fetchTotalPoolCases()" v-if="tabIndex === 1" class="pt-2" :display-assigned="false" :search-params="{'lastTask.lastPoolTask.operation': 0, status: 1}"></Table>-->
<!--          </b-tab>-->
          <ServicemanTasks :nextTabIndex="1" :tabIndex="tabIndex" v-if="isServiceman || isControlling || isSalesRepresentative"></ServicemanTasks>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Calendar from '@/components/Dashboard/Views/Timetable/components/Calendar/Calendar'
import VueCookie from 'vue-cookie'
import getId from '@/utils/getIdFromLink'
import DispatcherTasks from './components/DispatcherTasks'
import UpcomingRelations from '@/components/Dashboard/Views/common/UpcomingRelations'
import TimetableNotes from '@/components/Dashboard/Views/common/TimetableNotes'
import ApiService from '@/utils/ApiService'
import { checkPagePermission, checkPermission, getUserRoles } from '@/utils/checkRoles'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal'
import MeetingCreateModal from '@/components/Dashboard/Views/excmrelation/modals/MeetingCreateModal'
import UpdateTaskParamsModal from '@/components/Dashboard/Views/excmtask/modals/UpdateTaskParamsModal'
import Table from '@/components/Dashboard/Views/excmcase/Table'
import ServicemanTasks from '@/components/Dashboard/Views/Timetable/components/ServicemanTasks'
import { ENTRYPOINT } from '@/config/entrypoint'
import debounce from 'v-debounce'
import DispatchTaskModal from '@/components/Dashboard/Views/excmtask/components/DispatchTaskModal.vue'

export default {
  name: 'Dashboard',
  components: {
    DispatchTaskModal,
    UpdateTaskParamsModal,
    ServicemanTasks,
    Calendar,
    DispatcherTasks,
    UpcomingRelations,
    TimetableNotes,
    MeetingCreateModal,
    PhoneCreateModal,
    Table
  },
  directives: {
    debounce
  },
  computed: {
    ableToViewDailyPlan () {
      return checkPermission('servicemen', 'DailyPlanShow')
    },
    ableToAssignTask () {
      return checkPermission('tasks', 'EXCMTaskShow', 'dispatchTask')
    },
    ableToViewCases () {
      return checkPermission('cases', 'EXCMCaseList')
    },
    isServiceman () {
      return this.getRoles().includes('ROLE_SERVICEMAN') || this.getRoles().includes('ROLE_EXTERNAL_SERVICEMAN') || this.getRoles().includes('ROLE_SALES_REPRESENTATIVE')
    },
    isControlling () {
      return this.getRoles().includes('ROLE_CONTROLLING')
    },
    isSalesRepresentative () {
      return this.getRoles().includes('ROLE_SALES_REPRESENTATIVE')
    },
    canViewRelations () {
      return checkPermission('firms', 'EXCMRelationsList')
    },
    canViewNotes () {
      return checkPermission('notes', 'EXCMNoteList')
    },
    idUserData () {
      return this.$store.state.picker.current
    },
    currentUser () {
      const user = this.path + 'user_datas/' + getUserRoles().id_userdata
      if (this.idUserData) {
        return user === this.idUserData ? user : this.idUserData
      } else return user
    },
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    mobileView () {
      return this.$store.state.mobileView
    }
  },
  data () {
    return {
      delay: 500,
      contactType: 0,
      tabIndex: 0,
      totalPoolCases: 0,
      myCasesSearchParams: {
        caseQuickSearch: '',
        currentOwnerUserData: getUserRoles().id_userdata,
        status: 1
      }
    }
  },
  created () {
    this.getRoles()
    this.setCurrentUser()
    this.fetchTotalPoolCases()
  },
  beforeDestroy () {
    this.$store.state.picker.current = ''
  },
  beforeCreate () {
    checkPagePermission('dashboard', 'TimetableDashboard')
  },
  methods: {
    getRoles () {
      return getUserRoles().roles
    },
    getIdLink (link) {
      return getId(link)
    },
    async setCurrentUser () {
      const response = await new ApiService('user_datas/' + VueCookie.get('user_data_id')).getResults()
      this.$store.state.picker.current = response['@id']
    },
    async fetchTotalPoolCases () {
      const params = {
        status: 1,
        'lastTask.lastPoolTask.operation': 0
      }
      const response = await new ApiService('e_x_c_m_cases', params).getResults()
      this.totalPoolCases = response.totalItems
    }
  }
}
</script>
